import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Suppress benign ResizeObserver loop warnings (Radix Tabs/Select) that trigger the dev overlay
const roError = "ResizeObserver loop";
window.addEventListener("error", (e) => {
  if (e.message && e.message.includes(roError)) {
    e.stopImmediatePropagation();
  }
});

// Safety net for a known Radix bug: a Select/Dropdown opened inside a Dialog can leave
// `pointer-events: none` stuck on <body> after it closes, freezing the whole page
// (including the open dialog). Whenever no Radix popper is actually open, clear the lock.
if (typeof document !== "undefined") {
  const clearStuckPointerLock = () => {
    const popperOpen = document.querySelector("[data-radix-popper-content-wrapper]");
    if (!popperOpen && document.body.style.pointerEvents === "none") {
      document.body.style.pointerEvents = "";
    }
  };
  const observer = new MutationObserver(clearStuckPointerLock);
  observer.observe(document.body, { attributes: true, attributeFilter: ["style"] });
  document.addEventListener("pointerup", () => setTimeout(clearStuckPointerLock, 100), true);
}


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch(() => {}));
}
